import { useDispatch } from 'react-redux'
import { FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { setStage } from 'slices/drawer'
import { STATICS } from 'statics'
import { formatDate } from 'utils'
import { MESSAGES_DRAWER_STAGES } from '../../constants'
import './style.scss'

export function MessageItem({ message, setSelected }) {
  const { createdAt, title, visualized } = message
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  function handleSelectMessage() {
    sendEvent(FIREBASE_EVENTS.NOTIFICATION_OPEN)
    setSelected(message)
    dispatch(setStage(MESSAGES_DRAWER_STAGES.MESSAGE))
  }

  function renderStatus() {
    return (
      <span className={`status ${visualized ? '-visualized' : ''}`}>
        {visualized && <STATICS.CHECK_CIRCLE />}
      </span>
    )
  }

  return (
    <div
      className={`message-item ${visualized ? '-visualized' : ''}`}
      onClick={handleSelectMessage}
    >
      <div className='message-content'>
        <span className='date'>{formatDate(createdAt, 'dd MMM')}</span>
        <span className='title'>{title}</span>
      </div>
      {renderStatus()}

      <span>{'>'}</span>
    </div>
  )
}
